import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "../styles/legal.module.css";

const Terms = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className={styles.legalContainer}>
      <div className={styles.legalContent}>
        <header className={styles.legalHeader}>
          <Link to="/" className={styles.backLink}>←Home</Link>
          <h1>Terms and Conditions</h1>
          <p className={styles.lastUpdated}>Last updated: {new Date().toLocaleDateString()}</p>
        </header>

        <div className={styles.legalBody}>
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Memory Curve, you accept and agree to be bound by the terms and provision of this agreement.
              If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              Memory Curve is a web application designed to optimize your learning through spaced repetition techniques.
              Our service helps you track and manage your revision schedule to enhance memory retention and learning efficiency.
            </p>
          </section>

          <section>
            <h2>3. User Account and Registration</h2>
            <p>
              To access certain features of Memory Curve, you must register for an account. You agree to:
            </p>
            <ul>
              <li>Provide accurate, current, and complete information during the registration process</li>
              <li>Maintain and promptly update your account information</li>
              <li>Maintain the security of your password and account</li>
              <li>Accept all risks of unauthorized access to your account</li>
            </ul>
          </section>

          <section>
            <h2>4. Data Collection and Usage</h2>
            <p>
              Memory Curve collects and processes data necessary to provide our services, including:
            </p>
            <ul>
              <li>Revision data to display your learning progress and statistics</li>
              <li>Email addresses for account management and optional notifications</li>
              <li>Payment information processed securely through Stripe for premium features</li>
              <li>Calendar integration data when you choose to connect to Google Calendar</li>
            </ul>
            <p>
              All data collected is used solely to improve your learning experience and provide the services you've requested.
            </p>
          </section>

          <section>
            <h2>5. Security</h2>
            <p>
              We take the security of your data seriously. All passwords are securely hashed and stored using industry-standard encryption methods.
              However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2>6. Payment Terms</h2>
            <p>
              Premium features require payment processed through Stripe. By purchasing premium features, you agree to:
            </p>
            <ul>
              <li>Pay all fees associated with your selected plan</li>
              <li>Provide accurate payment information</li>
              <li>Accept that refunds are subject to our refund policy</li>
            </ul>
          </section>

          <section>
            <h2>7. Email Notifications</h2>
            <p>
              By creating an account, you may receive email notifications related to your revision schedule and account updates.
              You can opt out of non-essential notifications at any time through your account settings.
            </p>
          </section>

          <section>
            <h2>8. Prohibited Uses</h2>
            <p>You may not use Memory Curve:</p>
            <ul>
              <li>For any unlawful purpose or to solicit others to perform unlawful acts</li>
              <li>To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances</li>
              <li>To infringe upon or violate our intellectual property rights or the intellectual property rights of others</li>
              <li>To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate</li>
              <li>To submit false or misleading information</li>
            </ul>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>
              Memory Curve shall not be liable for any indirect, incidental, special, consequential, or punitive damages,
              including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the service.
            </p>
          </section>

          <section>
            <h2>10. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the application.
              Your continued use of Memory Curve after such modifications constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2>11. Contact Information</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us at:
            </p>
            <p>Email: <a href="mailto:support@memorycurve.fr">support@memorycurve.fr</a></p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms; 